var _rect, _path, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 14,
    height: 12,
    rx: 1,
    transform: "rotate(-180 15 15)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42331 13C6.34969 13 6.28834 12.9771 6.23926 12.9314C6.19018 12.8781 6.16564 12.8171 6.16564 12.7486C6.16564 12.7257 6.17382 12.6914 6.19018 12.6457L9.13497 6.37143H5.29448C5.21268 6.37143 5.14315 6.34476 5.08589 6.29143C5.02863 6.2381 5 6.17333 5 6.09714V5.28571C5 5.2019 5.02454 5.13333 5.07362 5.08C5.13088 5.02667 5.2045 5 5.29448 5H10.6933C10.7832 5 10.8569 5.02667 10.9141 5.08C10.9714 5.13333 11 5.2019 11 5.28571V6.00571C11 6.16571 10.9591 6.32952 10.8773 6.49714L7.95706 12.7257C7.90798 12.8095 7.85481 12.8781 7.79755 12.9314C7.74029 12.9771 7.66258 13 7.56442 13H6.42331Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 2.75,
    width: 14.5,
    height: 12.5,
    rx: 2.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(90 5 0)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(90 13 0)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive7);
export default __webpack_public_path__ + "static/media/archive-7.d5162f150caf52998a727e5d3561e7b5.svg";
export { ForwardRef as ReactComponent };